import(/* webpackMode: "eager" */ "/vercel/path0/packages/wello/src/app/error.tsx");
